<p>store-dashboard works!</p>
